module.exports = __webpack_public_path__ + "static/media/artist-order.9f590042.svg";